import { render, staticRenderFns } from "./IPayAlert.vue?vue&type=template&id=2292ca36&"
import script from "./IPayAlert.vue?vue&type=script&lang=js&"
export * from "./IPayAlert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports